module.exports = new __parcel__URL__("open-hihat_1.1fa9c461.mp3").toString();